import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { AddEmployeeDto } from '../../../../models/employee/add-employee-dto';
import { EmployeeService } from '../../../../services/employee/employee.service';

export class EmployeeDatabase {
    /** Stream that emits whenever the data has been modified. */
    dataChange: BehaviorSubject<AddEmployeeDto[]> = new BehaviorSubject<AddEmployeeDto[]>([]);

    get data(): AddEmployeeDto[] {
        return this.dataChange.value;
    }

    constructor(
        private employeeService: EmployeeService,
    ) {
        setTimeout(() => {
            this.employeeService.getAll().subscribe(response => {
                console.log('EmployeeService > response', response);
                for (const r of response) {
                    this.add(r);
                }
            }, () => {

            });
        }, 100);
    }

    public add(store: AddEmployeeDto) {
        const copiedData = this.data.slice();
        copiedData.push(store);
        this.dataChange.next(copiedData);
    }

    public edit(store: AddEmployeeDto) {
        const copiedData = this.data.slice();
        const index = copiedData.findIndex(st => st.Id === store.Id);
        copiedData[index] = store;
        this.dataChange.next(copiedData);
    }

    public delete(store: AddEmployeeDto) {
        const copiedData = this.data.slice();
        const index = copiedData.findIndex(st => st.Id === store.Id);
        copiedData.splice(index, 1);
        this.dataChange.next(copiedData);
    }

    refresh(event) {
        this.employeeService.employees = [];
        this.employeeService.employeesObject = {};
        this.dataChange.next([]);
        setTimeout(() => {
            this.employeeService.getAll().subscribe(response => {
                console.log('EmployeeService > response', response);
                for (const r of response) {
                    this.add(r);
                }
                event();
            }, () => {
                event();
            });
        }, 100);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/employees/employeeDatabase.ts